/**
 * Presentation only: mirrors backend creator_is_active, including its legacy
 * fully-verified fallback. NOT a permission or monetization check. Keep using
 * the existing server-provided eligibility flags for paid actions.
 */
export const hasActiveCreatorProfile = (user) => !!user && (
  user.creator_status === 'active' || !!(
    user.is_payout_ready &&
    user.stripe_connect_charges_enabled &&
    user.stripe_connect_payouts_enabled
  )
);